export interface BackendTimingEntry {
  method: string;
  url: string;
  status: number | string;
  durationMs: number;
}

export interface BackendTimingAccumulator {
  totalMs: number;
  count: number;
  entries: BackendTimingEntry[];
}

// Keyeado por el objeto `req` de Express de ESE request puntual. Al ser
// WeakMap, si por lo que sea nunca se llama a clearBackendTiming(), la
// entrada se libera sola en cuanto `req` deja de ser referenciado — no hay
// riesgo de memory leak ni de mezclar datos entre requests concurrentes.
const registry = new WeakMap<object, BackendTimingAccumulator>();

function getOrCreate(reqKey: object): BackendTimingAccumulator {
  let acc = registry.get(reqKey);
  if (!acc) {
    acc = { totalMs: 0, count: 0, entries: [] };
    registry.set(reqKey, acc);
  }
  return acc;
}

export function recordBackendTiming(
  reqKey: object,
  entry: BackendTimingEntry
): void {
  const acc = getOrCreate(reqKey);
  acc.totalMs += entry.durationMs;
  acc.count += 1;
  acc.entries.push(entry);
}

export function getBackendTiming(reqKey: object): BackendTimingAccumulator {
  return registry.get(reqKey) ?? { totalMs: 0, count: 0, entries: [] };
}

export function clearBackendTiming(reqKey: object): void {
  registry.delete(reqKey);
}
